import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'Beranda',
    component: () => import('../../components/views/Publik/Beranda.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/DaftarKonten',
    name: 'DaftarKonten',
    component: () => import('../../components/views/Publik/DaftarKonten.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/DaftarBerita',
    name: 'DaftarBerita',
    component: () => import('../../components/views/Publik/DaftarBerita.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/ListBerita/:id',
    name: 'ListBerita',
    component: () => import('../../components/views/Publik/ListBerita.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/Dashboard',
    name: 'Dashboard',
    component: () => import('../../components/views/Dashboard/Dashboard.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/InfoBeranda',
    name: 'InfoBeranda',
    component: () => import('../../components/views/Backoffice/InfoBeranda/InfoBeranda.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/ProsesInfoBeranda/:id',
    name: 'ProsesInfoBeranda',
    component: () => import('../../components/views/Backoffice/InfoBeranda/ProsesInfoBeranda.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/Konten',
    name: 'Konten',
    component: () => import('../../components/views/Backoffice/Konten/Konten.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/ProsesKonten/:id',
    name: 'ProsesKonten',
    component: () => import('../../components/views/Backoffice/Konten/ProsesKonten.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/Berita',
    name: 'Berita',
    component: () => import('../../components/views/Backoffice/Berita/Berita.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/ProsesBerita/:id',
    name: 'ProsesBerita',
    component: () => import('../../components/views/Backoffice/Berita/ProsesBerita.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/User',
    name: 'User',
    component: () => import('../../components/views/Backoffice/User/User.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/ProsesUser/:id',
    name: 'ProsesUser',
    component: () => import('../../components/views/Backoffice/User/ProsesUser.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/Slider',
    name: 'Slider',
    component: () => import('../../components/views/Backoffice/Slider/Slider.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/ProsesSlider/:id',
    name: 'ProsesSlider',
    component: () => import('../../components/views/Backoffice/Slider/ProsesSlider.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/SettingMenu',
    name: 'SettingMenu',
    component: () => import('../../components/views/Backoffice/SettingMenu/SettingMenu.vue'),
    meta: {
      transition: "zoom",
    },
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  mode: 'history',
  routes: routes,
  linkActiveClass: 'active',
})

export default router;
